import { BaseService } from '../base';
import type { PixAutomaticAccountResponse, PixParticipant } from './types';

export class PixAutomaticService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  /** Bancos ATIVOS no PIX cujo nome contém o termo (ou cujo ISPB começa com ele). */
  async searchParticipants(search: string): Promise<{
    success: boolean;
    data?: PixParticipant[];
    error?: string;
  }> {
    try {
      const query = new URLSearchParams({ search: search ?? '' });
      const response = await this.get(
        `/portal/v1/finance/pix-participants?${query.toString()}`,
        {},
        this.customBaseUrl
      );
      return await this.handleJsonResponse<PixParticipant[]>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao consultar os bancos do PIX',
      };
    }
  }

  /**
   * Conta do PIX Automático já gravada na proposta. `data` ausente (com
   * sucesso) quando a proposta ainda não tem conta — o 404 é o caso normal.
   */
  async getAccount(policyId: string): Promise<{
    success: boolean;
    data?: PixAutomaticAccountResponse;
    error?: string;
  }> {
    try {
      const response = await this.get(
        `/portal/v1/proposals/${encodeURIComponent(policyId)}/pix-automatic-account`,
        {},
        this.customBaseUrl
      );
      if (response.status === 404) return { success: true };
      return await this.handleJsonResponse<PixAutomaticAccountResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar a conta do PIX Automático',
      };
    }
  }
}

export const pixAutomaticService = new PixAutomaticService();

export type {
  PixAutomaticAccount,
  PixAutomaticAccountResponse,
  PixParticipant,
} from './types';
